<script>
    import { Peers } from '../../Peers.js';
    import PeerLabel from './PeerLabel.svelte';

    // self first so it anchors the right edge under row-reverse
    $: ordered = [...$Peers].sort((a, b) => (b.is_self === true) - (a.is_self === true));
</script>

{#if ordered.length > 0}
    <div class="peer-labels">
        {#each ordered as peer (peer.id)}
            <PeerLabel {peer}/>
        {/each}
    </div>
{/if}

<style lang="scss">
    .peer-labels {
        margin-left: auto;
        display: flex;
        flex-direction: row-reverse;
        flex-wrap: wrap;
        justify-content: flex-start; // with row-reverse, packs to the right edge
        gap: 10px;
        align-content: flex-start;
        align-self: center;
    }

    // When the toolbar is narrow enough that peer-labels wraps below the icons,
    // flip to left-aligned so the chips line up with the toolbar's left edge.
    @container (max-width: 700px) {
        .peer-labels {
            margin-left: 0;
            flex-direction: row;
        }
    }
</style>
